var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[(true)?_vm._t("default",null,{"authorization":true}):_vm._t("unauthorized")],2)}
var staticRenderFns = []

export { render, staticRenderFns }